// @owners { team: patients }
import { useMemo } from 'react';
import { useCartEssentials } from '~shared/features/essentials/hooks';
import { useOrderPricing } from '~shared/queries';

export const MINIMUM_THRESHOLD = 10;

export const useCartEssentialsPrice = () => {
  const { essentials, hasEssentials, hasNonEssentials } = useCartEssentials();
  const { orderPricing } = useOrderPricing();

  const totalPrice = essentials.reduce(
    (sum, prescription) => sum + (orderPricing?.item_pricing[prescription.id]?.prices[0]?.price || 0),
    0,
  );
  const essentialsOnlyPriceBelowMinimum = !hasEssentials || hasNonEssentials ? false : totalPrice < MINIMUM_THRESHOLD;
  const essentialsOnlyPriceMinRemainder = !essentialsOnlyPriceBelowMinimum
    ? null
    : (MINIMUM_THRESHOLD - totalPrice).toFixed(2);

  return useMemo(
    () => ({
      essentialsOnlyPriceBelowMinimum,
      essentialsOnlyPriceMinRemainder,
      MINIMUM_THRESHOLD,
      totalPrice,
    }),
    [essentialsOnlyPriceBelowMinimum, essentialsOnlyPriceMinRemainder, totalPrice],
  );
};
